export function WarehouseSleeveIcon() {
  return (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.1236 21.6017C10.9411 21.8942 9.15415 23.5809 8.54116 25.8181L1 21.3232L1.96296 19.943C3.36998 17.9278 6.03077 17.3442 8.11207 18.5929L13.1236 21.6017Z"
        fill="#E73A42"
      />
      <path
        d="M13.8007 26.7149H17.5506C17.5506 24.7703 15.8713 23.1946 13.8007 23.1946C11.7294 23.1946 10.0508 24.771 10.0508 26.7149H13.8007Z"
        fill="#E73A42"
      />
      <path
        d="M19.3043 14.9429C17.1217 15.2354 15.3348 16.9221 14.7218 19.1593L7.18066 14.6644L8.14362 13.2842C9.55064 11.269 12.2114 10.6854 14.2927 11.9341L19.3043 14.9429Z"
        fill="#E73A42"
      />
      <path
        d="M19.9814 20.0561H23.7313C23.7313 18.1115 22.052 16.5358 19.9814 16.5358C17.91 16.5358 16.2314 18.1122 16.2314 20.0561H19.9814Z"
        fill="#E73A42"
      />
      <path
        d="M26.5728 8.94963C24.3903 9.24214 22.6034 10.9288 21.9904 13.166L14.4492 8.67109L15.4122 7.29088C16.8192 5.27568 19.48 4.69214 21.5613 5.9408L26.5728 8.94963Z"
        fill="#E73A42"
      />
      <path
        d="M27.2499 14.0614H30.9998C30.9998 12.1167 29.3205 10.541 27.2499 10.541C25.1786 10.541 23.5 12.1175 23.5 14.0614H27.2499Z"
        fill="#E73A42"
      />
    </svg>
  );
}

export function WarehouseStationaryIcon() {
  return (
    <svg viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_197_3019)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.32355 6.58321C0.941345 6.74246 0.692383 7.11591 0.692383 7.52996V21.2052H3.76931V9.92312C3.76931 9.35668 4.22851 8.89748 4.79495 8.89748H21.2052C21.7717 8.89748 22.2308 9.35668 22.2308 9.92312V21.2052H25.3078V7.52996C25.3078 7.11591 25.0588 6.74246 24.6766 6.58321L13.3945 1.88236C13.1421 1.77717 12.858 1.77717 12.6056 1.88236L1.32355 6.58321Z"
          fill="#007E3C"
        />
        <path
          d="M19.1536 17.1025H6.84595C6.27951 17.1025 5.82031 17.5617 5.82031 18.1282V20.1795C5.82031 20.7459 6.27951 21.2051 6.84595 21.2051H19.1536C19.7201 21.2051 20.1793 20.7459 20.1793 20.1795V18.1282C20.1793 17.5617 19.7201 17.1025 19.1536 17.1025Z"
          fill="#007E3C"
        />
        <path
          d="M19.1536 10.9487H6.84595C6.27951 10.9487 5.82031 11.4079 5.82031 11.9744V14.0257C5.82031 14.5921 6.27951 15.0513 6.84595 15.0513H19.1536C19.7201 15.0513 20.1793 14.5921 20.1793 14.0257V11.9744C20.1793 11.4079 19.7201 10.9487 19.1536 10.9487Z"
          fill="#007E3C"
        />
      </g>
      <defs>
        <clipPath id="clip0_197_3019">
          <rect
            width="24.6154"
            height="24.6154"
            fill="white"
            transform="translate(0.692383 0.692261)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
